import { Link } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useClientId } from "@/features/clients/detail/use-client-id";
import { InvoicesPage } from "@/features/invoices/invoices-page";

export function ClientInvoicesPage() {
  const clientId = useClientId();
  return (
    <div className="space-y-3">
      <div className="flex justify-end">
        <Button asChild size="sm">
          <Link to="/invoices/new" search={{ client: clientId }}>
            <Plus />
            New invoice
          </Link>
        </Button>
      </div>
      <InvoicesPage clientId={clientId} embedded />
    </div>
  );
}
